import { z } from "zod";
import { AdvisorId, TaskId } from "../../Types";
import { TaskV3_1 } from "../Types";
import getTasksV3_1 from "./getTasks.v3_1";
const GetTasksBatchRequest = z.object({
    taskIds: TaskId.array(),
    advisorId: AdvisorId.optional(),
});
const GetTasksBatchResponse = z.object({
    values: TaskV3_1.array(),
});
export default async function getTasksBatch(config, payload) {
    if (payload.taskIds.length === 0) {
        return { values: [] };
    }
    const result = await getTasksV3_1(config, {
        filterByTaskIds: payload.taskIds,
        filterByAdvisor: payload.advisorId ? [payload.advisorId] : undefined,
    });
    return {
        values: result.values,
    };
}
//# sourceMappingURL=getTasksBatch.js.map